<template>
  <div class="editor-double-switcher">
    <span @click="clickHandler('left')" :class="getLeftClass">
      {{ left }}
    </span>
    <i-switch v-model="contract[value]" />
    <span @click="clickHandler('right')" :class="getRightClass">
      {{ right }}
    </span>
  </div>
</template>

<script>
export default {
  props: ['contract', 'value', 'left', 'right'],
  computed: {
    getLeftClass () {
      return this.contract[this.value] ? 'ms-help' : 'ms-link'
    },
    getRightClass () {
      return this.contract[this.value] ? 'ms-link' : 'ms-help'
    }
  },
  methods: {
    clickHandler (type) {
      const value = type !== 'left'
      this.contract[this.value] = value
    }
  }
}
</script>

<style lang="less">
.editor-double-switcher {
  display: flex;
  align-items: center;

  .ms-link, .ms-help {
    font-weight: 500;
    cursor: pointer;
  }

  .ms-help {
    opacity: 0.8;
  }

  .ivu-switch {
    margin: 0 8px;
  }
}

.dark .editor-double-switcher .ivu-switch {
  background-color: @dt-dark-bg !important;
  border-color: @dt-dark-main !important;
}

.light .editor-double-switcher .ivu-switch {
  background-color: #ccc !important;
  border-color: #ccc !important;
}
</style>
